<template>
  <v-card>
    <v-container id="dropdown-example" grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card-title class="title pa-0"> {{ $t('documents.upload.more_then_limit_title', {'n': 100 }) }}</v-card-title>
        </v-flex>
        <v-flex xs12 class="text-xs-left">
          <v-list dense class="pa-0 ma-0">
            <p>{{ $t('documents.upload.title_available_internet') }}</p>
            <small style="display: block">{{ $t('documents.upload.more_then_limitA') }}</small>
            <small style="display: block">{{ $t('documents.upload.more_then_limitB') }}</small>
            <small style="display: block">{{ $t('documents.upload.more_then_limitC') }}</small>
            <hr />
            <p>{{ $t('documents.upload.title_unavailable_internet') }}</p>
            <small style="display: block">{{ $t('documents.upload.more_then_limit2_1', { 'n': 100 }) }}</small>
            <small style="display: block">{{ $t('documents.upload.more_then_limit2_2') }}</small>
            <small style="display: block">{{ $t('documents.upload.more_then_limit2_3') }}</small>
            <hr />
            <p>{{ $t('documents.upload.title_instructions') }}</p>
            <small style="display: block">{{ $t('documents.upload.seminar_instruction1_1') }}</small>
            <small style="display: block">{{ $t('documents.upload.seminar_instruction1_2') }}</small>
            <small style="display: block">{{ $t('documents.upload.seminar_instruction2_1') }}</small>
            <small style="display: block">{{ $t('documents.upload.seminar_instruction2_2') }}</small>
            <hr />
            <p>{{ $t('documents.upload.more_then_limit2_41') }}</p>
            <p>
              <a class="blue--text" :href="share1" target="_blank">
                <img :src="logo1" class="fileshare_logo" />
              </a>
              {{ $t('documents.upload.more_then_limit2_40', { 'size': size1 }) }}
            </p>
            <p>
              <a class="blue--text" :href="share2" target="_blank"> <img :src="logo2" class="fileshare_logo" /> </a> 
            </p>
            <!--<p>
              <a class="blue--text" :href="share3" target="_blank"> {{share3 }} </a> {{ $t('documents.upload.more_then_limit2_40', { 'size': size3 }) }}
            </p>-->
            <p>
              <a class="blue--text" :href="share4" target="_blank"> <img :src="logo4" class="fileshare_logo" /> </a> {{ $t('documents.upload.more_then_limit2_40', { 'size': size4 }) }}
            </p>
          </v-list>
        </v-flex>

      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    data() {
      return {
        share1: 'https://www.dropbox.com',
        size1: '0 MB',
        logo1: '/assets/images/logos/fileShare/dropbox_logo.png',

        share2: 'https://www.google.com/drive/',
        size2: '0 MB',
        logo2: '/assets/images/logos/fileShare/googledrive_logo.png',



        share4: 'https://wetransfer.com/',
        size4: '0 GB',
        logo4: '/assets/images/logos/fileShare/wetransfer_logo.png'
      }
    }
  }
</script>

<style scoped>
  .fileshare_logo {
    max-width: 155px;
  }
</style>



// WEBPACK FOOTER //
// VueSrc/SeminarTask/components/SeminarUploadLarge.vue